module.exports = __webpack_public_path__ + "img/blog-6.8adf93e3.jpg";